export default "__VITE_ASSET__BIkKQ7LF__"